import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "app-join-poup",
    templateUrl: "./join-poup.component.html",
    styleUrls: ["./join-poup.component.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class JoinPoupComponent {
  constructor(private matDialog: MatDialog) {}

  close() {
    this.matDialog.closeAll();
  }
}
